import React from 'react';

import MuiTooltip from '@mui/material/Tooltip';

type Props = {
  title: string;
  children: string | JSX.Element;
};

export default function TooltipUnderline({ children, ...props }: Props): JSX.Element {
  return (
    <MuiTooltip {...props}>
      <span style={{ borderBottom: props.title ? '1px dashed currentColor' : 'none' }}>{children}</span>
    </MuiTooltip>
  );
}
